/**
 * Shared granular expense categories for bank/GST lines and Daily Expenses.
 * Order matches product screenshots (plus logical groupings).
 */
export const GRANULAR_EXPENSE_CATEGORIES = [
  '',
  'Food & Ingredients',
  'Beverages & Alcohol',
  'Packaging & Supplies',
  'Staff Wages',
  'Casual Labour',
  'Superannuation',
  'Rent & Lease',
  'Gas & Electricity',
  'Water',
  'Phone & Internet',
  'POS & Software',
  'Marketing & Ads',
  'Delivery Platform Fees',
  'Equipment & Maintenance',
  'Cleaning & Hygiene',
  'Uniforms & Laundry',
  'Accounting & Legal',
  'Bank & Card Fees',
  'Insurance',
  'Licences & Permits',
  'Vehicle & Transport',
  'Loan Repayment',
  'Other Expense',
] as const;

/** Daily expenses use this string for staff labour (was "Labour / Wages"). */
export const DAILY_EXPENSE_STAFF_WAGES_CATEGORY = 'Staff Wages';

const LEGACY_TO_GRANULAR: Record<string, string> = {
  Rent: 'Rent & Lease',
  Utilities: 'Gas & Electricity',
  Supplies: 'Packaging & Supplies',
  'Labour / Wages': 'Staff Wages',
  Marketing: 'Marketing & Ads',
  'Repairs & Maintenance': 'Equipment & Maintenance',
  Insurance: 'Insurance',
  'Bank Fees': 'Bank & Card Fees',
  'Delivery / Transport': 'Delivery Platform Fees',
  'Food & Beverage (COGS)': 'Food & Ingredients',
  Cleaning: 'Cleaning & Hygiene',
  Equipment: 'Equipment & Maintenance',
  'Professional Fees': 'Accounting & Legal',
  Other: 'Other Expense',
};

/** Map old category labels to the new list (for existing daily expense rows). */
export function migrateLegacyExpenseCategoryDisplay(cat: string | undefined): string {
  if (!cat || !cat.trim()) return '';
  const t = cat.trim();
  return LEGACY_TO_GRANULAR[t] ?? t;
}
